import { Injectable } from '@angular/core';
import { Subject, Observable, BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: "root",
})
export class StreamService {

  chatConfig: any;
  newDm: any;
  constructor() {
    this.setInitialChatConfig();
  }

	alertChannel: Subject<any> = new Subject();
	alertSubscription$ = this.alertChannel.asObservable();
	streamMessage(data: any) {
		let obj = { data: data };
		this.alertChannel.next(obj);
	}

	getSubscription(): Observable<any> {
		return this.alertSubscription$;
	}

	//for filter
	alertFilter: BehaviorSubject<any> = new BehaviorSubject(new Array<any>());
	alertFilterSubscription$ = this.alertFilter.asObservable();
	streamFilterMessage(data: any) {
		let obj = data;
		this.alertFilter.next(obj);
	}

	getFilterSubscription(): Observable<any> {
		return this.alertFilterSubscription$;
	}

	//for Header filter
	headerFilter: Subject<any> = new Subject();
	headerFilterSubscription$ = this.headerFilter.asObservable();
	streamHeaderFilterMessage(data: any) {
		let obj = data;
		this.headerFilter.next(obj);
	}

	getHeaderFilterSubscription(): Observable<any> {
		return this.headerFilterSubscription$;
	}

	// Observable string sources
	private emitChangeSource = new Subject<any>();
	// Observable string streams
	changeEmitted$ = this.emitChangeSource.asObservable();
	// Service message commands
	emitChange(change: any) {
		this.emitChangeSource.next(change);
	}

	private realoadNoti = new Subject<any>();
	realoadNotification(change: any) {
		this.realoadNoti.next(change);
	}
	changeNotif$ = this.realoadNoti.asObservable();

	// FOrms
	alertForm: Subject<any> = new Subject();
	alertDevicetSubscribe$ = this.alertForm.asObservable();
	formStream(data: any) {
		let obj = { data: data };
		this.alertForm.next(obj);
	}
	getformStream(): Observable<any> {
		return this.alertDevicetSubscribe$;
	}

	// CHAT MESSAGE ADD MEMBER
	alertMember: Subject<any> = new Subject();
	alertChatMentionSubscribe$ = this.alertMember.asObservable();
	chatStream(data: any) {
		let obj = { data: data };
		this.alertMember.next(obj);
	}
	getMemberChatStream(): Observable<any> {
		return this.alertChatMentionSubscribe$;
	}

	// CHAT CONFIGURATION
	private chatConfig$ = new BehaviorSubject<any>('');
	private newDm$ = new BehaviorSubject<any>('');
	public getChatConfigObs(): Observable<any> {
		return this.chatConfig$.asObservable();
	}
	public getNewDm(): Observable<any> {
		return this.newDm$.asObservable();
	}
	setChatConfigObs(data: any) {
		this.chatConfig = {
			chatType: typeof data.chatType == "string" ? data.chatType : this.chatConfig.chatType,
			receiverId: typeof data.receiverId == "string" ? data.receiverId : this.chatConfig.receiverId,
			studyData: { ...this.chatConfig.studyData, ...data.studyData },
			circleData: { ...this.chatConfig.circleData, ...data.circleData },
			circleGroupData: { ...this.chatConfig.circleGroupData, ...data.circleGroupData },
			otherUserData: { ...this.chatConfig.otherUserData, ...data.otherUserData },
			searchData: { ...this.chatConfig.searchData, ...data.searchData },
			redirectionData: { ...this.chatConfig.redirectionData, ...data.redirectionData },
			searchTextCopy: typeof data.searchTextCopy == "string" ? data.searchTextCopy : this.chatConfig.searchTextCopy,
		};

		if (this.chatConfig.searchData.clear) {
			this.chatConfig.searchData = { isModalOpen: false, showSearchResults: false, text: "", category: "", circleId: "", userId: "", conversationName: "" };
			this.chatConfig.searchTextCopy = "";
		}
		this.chatConfig$.next(this.chatConfig);
		localStorage.setItem("chatConfig", JSON.stringify(this.chatConfig));
	}

  setInitialChatConfig(setDefault: boolean = false) {
    let savedChatConfig = localStorage.getItem("chatConfig");
	if (savedChatConfig && !setDefault) { 
		this.chatConfig = JSON.parse(savedChatConfig);
		this.chatConfig.searchData = { ...this.chatConfig.searchData, isModalOpen: false };
	}
    else {
      this.chatConfig = {
        chatType: "circle",
        receiverId: "",
        studyData: { studyId: "", studyNumber: "" },
        circleData: { circleName: "", circleProfilePic: "", circleId: "", memberType: "", ownerId: "" },
        circleGroupData: { circleGroupId: "", circleGroupName: "", isAllMemberGroup: false },
        otherUserData: { conversationId: "", userName: "", userProfilePic: "", userId: "", isOnline: false },
		searchData: { isModalOpen: false, showSearchResults: false, text: "", category: "", circleId: "", userId: "", conversationName: "" },
		redirectionData: { isRedirected: false, isReply: false, chatId: "", replyId: "" },
		searchTextCopy: "",
      };
    }
    this.setChatConfigObs(this.chatConfig);
	}
	setAddNewDm(data: any) {
		this.newDm = {
			newDmType: typeof data.chatType == "string" ? data.chatType : this.newDm.chatType,

		};
		this.newDm$.next(this.newDm);
	}
}
